import news from './news.vue';

export default news;
